import React from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import Spinner from '@divvy-web/skylab.spinner'

import styles from './styles.module.scss'

/**
 * Suspense fallback for lazy route chunks. The spinner mounts immediately but
 * stays invisible for the first 300ms via a CSS animation delay, so fast chunk
 * loads never flash a loader.
 */
const FullPageFallback = () => {
  const [getClassName] = useNameFormatter('FullPageFallback')
  return (
    <div className={styles[getClassName('')]}>
      <Spinner fullPage />
    </div>
  )
}

export default FullPageFallback
